(function () {
  'use strict';

  /* ── SCROLL REVEAL ─────────────────────────────────────────────────── */
  function zvhReveal() {
    var els = document.querySelectorAll('.zvr:not(.revealed)');
    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('revealed'); });
      return;
    }

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('revealed');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.06, rootMargin: '0px 0px -10px 0px' });

    /* Double rAF — ensures browser has painted opacity:0 before observing */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        els.forEach(function (el) { obs.observe(el); });
      });
    });
  }

  /* ── BESTSELLERS INFINITE CAROUSEL ───────────────────────────────────── */
  function zvhCarousel() {
    var track = document.querySelector('.zvh-bestsellers__track');
    if (!track) return;

    var speed  = 0.55;   /* px per frame */
    var pos    = 0;
    var paused = false;
    var halfW  = 0;

    function getHalfW() {
      if (halfW > 0) return halfW;
      var gap   = parseFloat(getComputedStyle(track).gap) || 18;
      var cards = track.querySelectorAll('.zvh-prod-card:not([aria-hidden])');
      cards.forEach(function (c) { halfW += c.offsetWidth + gap; });
      return halfW;
    }

    function tick() {
      if (!paused) {
        var w = getHalfW();
        if (w > 0) {
          pos += speed;
          if (pos >= w) pos -= w;
          track.style.transform = 'translateX(-' + pos.toFixed(2) + 'px)';
        }
      }
      requestAnimationFrame(tick);
    }

    /* Pause on hover */
    track.addEventListener('mouseenter', function () { paused = true; });
    track.addEventListener('mouseleave', function () { paused = false; });

    /* Touch swipe */
    var ts = 0, ps = 0;
    track.addEventListener('touchstart', function (e) {
      paused = true;
      ts = e.touches[0].clientX;
      ps = pos;
    }, { passive: true });

    track.addEventListener('touchmove', function (e) {
      var dx = ts - e.touches[0].clientX;
      var w  = getHalfW();
      pos = ps + dx;
      if (pos < 0) pos += w;
      if (pos >= w) pos -= w;
      track.style.transform = 'translateX(-' + pos.toFixed(2) + 'px)';
    }, { passive: true });

    track.addEventListener('touchend', function () { paused = false; }, { passive: true });

    requestAnimationFrame(tick);
  }

  /* ── INIT ───────────────────────────────────────────────────────────── */
  function init() {
    zvhReveal();
    zvhCarousel();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
